import { IPlatformContext } from '@core/models';

export class GetPlatformContexts {
  static readonly type = '[PlatformContext] Get PlatformContexts';
  static readonly desc = 'Get Platform Contexts';

  constructor() {}
}

export class GetPlatformsStatus {
  static readonly type = '[PlatformContext] Get Platforms Status';
  static readonly desc = 'Get Platforms Status';

  constructor() {}
}

export class UpdatePlatformStatus {
  static readonly type = '[PlatformContext] Update Status';
  static readonly desc = 'Update Platform Status';

  constructor(public payload: Pick<IPlatformContext, 'source' | 'status'>) {}
}
